import React, { useEffect, useState } from "react";

// Styles
import "./Recovery.css";

// Components
import PasswordResetSuccess from "./RecoveryComponents/PasswordResetSuccess.component";
import Stepper from "../Stepper/Stepper.component";
import RecoveryStepOne from "./RecoverySteps/RecoveryStepOne.component";
import RecoveryStepTwo from "./RecoverySteps/RecoveryStepTwo.component";
import RecoveryStepThree from "./RecoverySteps/RecoveryStepThree.component";
import { MixPanel } from "../../shared/MixPanel/MixPanel";
import Enter2FACode from "../../modals/Modals/Enter2FACode/Enter2FACode";
import { authAjax } from "../../redux/actions/auth";
import { useDispatch } from "react-redux";

export default function Recovery() {
  // State
  const [stateToken, setStateToken] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [multiStepMenu, setMultiStepMenu] = useState("stepOne");
  const [mfaRequired, setMfaRequired] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    MixPanel.track(`Page View: ResetPassword.tsx`, {
      page: "ResetPassword.tsx",
    });
  }, []);

  const authHandler = (loginData) => {
    dispatch(authAjax(loginData));
  };

  //JSX Template
  return (
    <div className="center-container">
      <div className="center-container-wrapper">
        <div className="center-element">
          {!mfaRequired ? (
            <div className="normal-1x zoomIn">
              {/*ALGORITHM FOR STEP UI*/}
              <div className="tfx-step grid__full">
                <div className="form-steps">
                  <Stepper
                    id="stepOne"
                    step="1"
                    text="Verify Email"
                    active={multiStepMenu === "stepOne" ? true : false}
                  />
                  <Stepper
                    id="stepTwo"
                    step="2"
                    text="Verify Pin Code"
                    active={multiStepMenu === "stepTwo" ? true : false}
                  />
                  <Stepper
                    id="stepThree"
                    step="3"
                    text="Password Update"
                    active={multiStepMenu === "stepThree" ? true : false}
                  />
                  <Stepper
                    id="stepFour"
                    step="4"
                    text="Complete Setup"
                    active={multiStepMenu === "stepFour" ? true : false}
                    lastStep={true}
                  />
                </div>
              </div>

              {/*RECOVER PASSWORD UI*/}
              {(() => {
                switch (multiStepMenu) {
                  case "stepOne":
                    return (
                      <RecoveryStepOne
                        setStateToken={setStateToken}
                        setMultiStepMenu={setMultiStepMenu}
                        setEmail={setEmail}
                      />
                    );
                  case "stepTwo":
                    return (
                      <RecoveryStepTwo
                        state_token={stateToken}
                        setMultiStepMenu={setMultiStepMenu}
                        setOtp={setOtp}
                      />
                    );
                  case "stepThree":
                    return (
                      <RecoveryStepThree
                        state_token={stateToken}
                        setMultiStepMenu={setMultiStepMenu}
                        email={email}
                        otp={otp}
                        setMfaRequired={setMfaRequired}
                      />
                    );
                  case "stepFour":
                    return <PasswordResetSuccess />;
                  default:
                    return null;
                }
              })()}
            </div>
          ) : (
            <div className="Login center-container  normal-1x zoomIn">
              <div className="center-container-wrapper">
                <Enter2FACode onAuth={authHandler} mfaRequired={mfaRequired} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
